import React, { useContext } from 'react';
import {
	IStyleSettingsImageUploaderContext,
	StyleSettingsImageUploaderContext,
} from '../styleSettingsImageUploaderState/styleSettingsImageUploaderContext';
import { IMaxFileSizeMBStyleSettings } from 'types';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalSentErrorNew } from 'components/ModalWindows/ModalSentErrorNew';

interface IProps {
	maxFileSizeMB?: IMaxFileSizeMBStyleSettings;
}

export const ErrorModalsNew: React.FC<IProps> = ({ maxFileSizeMB }) => {
	const { changeTypeOfErrorModalWindow, typeOfErrorModalWindow } = useContext<IStyleSettingsImageUploaderContext>(
		StyleSettingsImageUploaderContext,
	);

	const handleCloseModal = () => {
		changeTypeOfErrorModalWindow(null);
	};

	return (
		<ModalWrapper isVisible={!!typeOfErrorModalWindow}>
			{typeOfErrorModalWindow === 'imgFileSizeExceeded' && (
				<ModalSentErrorNew
					onConsentEvent={handleCloseModal}
					description="fileSizeExceeded"
					translationOptions={{ size: `${maxFileSizeMB?.img}MB` }}
				/>
			)}
			{typeOfErrorModalWindow === 'gifFileSizeExceeded' && (
				<ModalSentErrorNew
					onConsentEvent={handleCloseModal}
					description="fileSizeExceeded"
					translationOptions={{ size: `${maxFileSizeMB?.gif}MB` }}
				/>
			)}
			{typeOfErrorModalWindow === 'fileUploadError' && (
				<ModalSentErrorNew onConsentEvent={handleCloseModal} description="fileUploadError" />
			)}
			{typeOfErrorModalWindow === 'fileDownloadError' && (
				<ModalSentErrorNew onConsentEvent={handleCloseModal} description="fileDownloadError" />
			)}
			{typeOfErrorModalWindow === 'invalidImageFormat' && (
				<ModalSentErrorNew
					onConsentEvent={handleCloseModal}
					description="invalidFileFormatPhoto"
					translationOptions={{ formats: '.jpeg, .jpg, .png' }}
				/>
			)}
			{typeOfErrorModalWindow === 'invalidGifFormat' && (
				<ModalSentErrorNew
					onConsentEvent={handleCloseModal}
					description="invalidFileFormatGif"
					translationOptions={{ formats: '.gif' }}
				/>
			)}
		</ModalWrapper>
	);
};
